import { useEffect } from "react"
import DTable from "../../../components/DTable/DTable"
import { useFoods } from "./FoodsStore"
import { Image } from "antd"
import Add from "./Add"
import Edit from "./Edit"

const Foods = () => {
    const { getFoods, foods, columns, deleteFood } = useFoods()

    useEffect(() => {
        getFoods()
    }, [getFoods])
    console.log(foods);

    return (
        <>
            <DTable
                columns={columns}
                pageName="Taomlar"
                dataSource={foods}
                AddComponent={Add}
                selectable={true}
                searchable={true}
                EditComponent={Edit}
                addModalTitle="Yangi taom qo'shish"
                editModalTitle="Taomni tahrirlash"
                onRefresh={() => { }}
                onDelete={deleteFood}
            />
        </>
    )
}

export default Foods